import React, { Component } from 'react';
import $ from "jquery";
import RightMenu from '../components/RightMenu';
import { Link } from 'react-router-dom';
import * as requestLib from '../lib/requestLib'

export default class ErrorNoResultHeader extends Component {
    constructor(props) {
        super(props);

        this.state = {
            viewMenu: false,
            userName: '',
            query: '',
        };

        this.baseUrl = requestLib.getUrl();

    }

    getCookie(name) {
        let value = "; " + document.cookie;
        let parts = value.split("; " + name + "=");
        if (parts.length === 2) return parts.pop().split(";").shift();
    }

    search() {
        let query = this.state.query;
        let url = window.location.href;
        url = url.split('?s=');
        url = url[0] + '?s=' + query;

        window.location = url;
        window.location.reload();
    }

    componentWillMount() {

        let accessToken = this.getCookie('accessToken');
        let url = window.location.href;
        if (url.indexOf("localhost") !== -1) {
            accessToken = "4276a4767834093a95444c2cdb5657f9d8672e2add97aa023a6418fc68fc285c";
        }


        $.ajax({
            url: this.baseUrl + "api/Group/getUserPayInfo",
            data: { userToken: accessToken },
            method: "get",
            dataType: "json",
            success: function (response) {

                if (response.status === false || response.data.search_permission === false) {
                    this.setState({ permissionAlert: true })
                } else {
                    this.setState({ userName: response.data.lastName });
                }


            }.bind(this),
            error: function (e) {

            }.bind(this)
        });

    }

    menuToggle() {
        this.setState({ viewMenu: !this.state.viewMenu })
    }

    handleKeyPress = event => {
        let keycode = event.keycode ? event.keycode : event.which ? event.which : event.char;
        if (keycode === 13) {
            this.search();
            return false;
        }
    };

    render() {

        return (
            <header>
                <div className="logo">
                    <a href={this.baseUrl + "main"}>
                        <img src="//pro.mimic.us/assets/img/logo.svg" />
                    </a>
                </div>

                <div className="search top-search">
                    <div className="searchWrap">
                        <div className="left">
                            <img src="http://pro.mimic.us/assets/img/search.png" className="search-img" />
                            <input type="text" id="queryString" value={this.state.query}
                                onChange={e => this.setState({ query: e.target.value })}
                                onKeyPress={e => this.handleKeyPress(e)}
                            />
                            <button className="close-btn" onClick={() => this.setState({ query: '' })}></button>
                        </div>
                        <div className="right">
                            <button className="searchBtn" onClick={this.search.bind(this)}>search</button>
                        </div>
                        <Link to="/advanced" className="advancedSearch">Advanced Search</Link>
                    </div>
                </div>


                <div className="profileBtn">
                    <i className="fas fa-user-circle"></i>
                    <span>{this.state.userName}</span>
                    <div id="userMenu">
                        <ul>
                            <li>
                                <a href={this.baseUrl + "setting"}>setting</a>
                            </li>
                            <li>
                                <a href={this.baseUrl + "sse/user/logout"}>logout</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <button className={this.state.viewMenu ? 'menuBtn menuShow' : 'menuBtn'} onClick={this.menuToggle.bind(this)}>
                    <ul>
                        <li />
                        <li />
                        <li />
                    </ul>
                </button>

                <RightMenu show={this.state.viewMenu ? 'true' : 'false'} />
            </header>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/errorNoResultHeader.js